export default function AdReviewNotice() {
  return (
    <div className="w-full px-4 py-8 ">
      <h1 className="text-xl font-semibold mb-4">Your Ad Campaign Is Under Review</h1>
      <p className="mb-6">
        Thank you for submitting your ad campaign! To ensure a <strong>safe</strong> and high-quality experience for all users, every campaign goes through a standard{" "}
        <strong>review process</strong> before it can go live on our platform.
      </p>
      <section className="mb-6">
        <h2 className="text-xl font-semibold mb-2">Why We Review Ads</h2>
        <p>
          We take ad quality and compliance seriously. Our review process is designed to ensure that all advertising content aligns with our community guidelines, advertising
          policies, and legal standards. This helps maintain a trusted environment for both advertisers and viewers.
        </p>
      </section>

      <section className="mb-6">
        <h2 className="text-xl font-semibold mb-2">What Happens During the Review</h2>
        <p className="mb-2">Once you submit your campaign, our system — along with our moderation team — reviews various elements of your ad, including:</p>
        <ul className="list-disc list-inside space-y-1">
          <li>
            <strong>Text and caption content</strong>
          </li>
          <li>
            <strong>Images, videos, and creative elements</strong>
          </li>
          <li>
            <strong>Targeting details and landing pages</strong>
          </li>
          <li>
            <strong>Compliance with community standards and ad policies</strong>
          </li>
        </ul>
        <p className="mt-2">
          We check for issues such as misleading claims, inappropriate content, prohibited products/services, or any content that may violate local regulations.
        </p>
      </section>

      <section className="mb-6">
        <h2 className="text-xl font-semibold mb-2">How Long Does It Take?</h2>
        <p>
          Most reviews are completed within <strong>24 hours</strong>, but in some cases, it may take a bit longer — especially if the ad contains complex or sensitive material. We
          appreciate your patience during this time.
        </p>
      </section>

      <section className="mb-6">
        <h2 className="text-xl font-semibold mb-2">What You Can Do</h2>
        <ul className="list-disc list-inside space-y-1">
          <li>
            <strong>Keep an eye on your notifications</strong> – We'll alert you as soon as your ad is approved or if any changes are needed.
          </li>
          <li>
            <strong>Double-check our ad guidelines</strong> – Making sure your ad follows our rules can help speed up the review process.
          </li>
          <li>
            <strong>Edit and resubmit if needed</strong> – If your ad is rejected, you'll be able to make adjustments and resubmit for another review.
          </li>
        </ul>
      </section>

      <section>
        <h2 className="text-xl font-semibold mb-2">Thanks for Your Patience</h2>
        <p>
          We understand that you're excited to get your campaign in front of your audience — and we’re just as excited to help you reach them. Thanks for bearing with us while we
          ensure everything is set up properly.
        </p>
        <p className="mt-2">If you have any questions or need assistance, feel free to reach out to our support team.</p>
      </section>
    </div>
  );
}
